import { define, html, router, store } from "hybrids";

import layout from "~/factories/layout";
import Broadcast from "~/stores/Broadcast";

import Amount from "./Amount";
import Confirm from "./Confirm";

export interface VBroadcastDonateView {
  broadcast?: Broadcast;
  views: HTMLElement[];
}

export default define<VBroadcastDonateView>({
  tag: "v-broadcast-donate-view",
  broadcast: store(Broadcast),
  views: router([Amount, Confirm], { params: ["broadcast"] }),
  render: layout("flex"),
  content: ({ broadcast, views }) => html`
    <v-broadcast-container grow overflow>
      ${store.ready(broadcast) && views}
    </v-broadcast-container>
  `,
});
